import { render } from "./BannerWSOP.vue?vue&type=template&id=0ec49aec&scoped=true"
import script from "./BannerWSOP.vue?vue&type=script&lang=js"
export * from "./BannerWSOP.vue?vue&type=script&lang=js"

import "./BannerWSOP.vue?vue&type=style&index=0&id=0ec49aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec49aec"]])

export default __exports__